export const initialise = () => {
    const alerts = document.querySelectorAll<HTMLDialogElement>('.alert')
    alerts.forEach((alert) => {
        if (!(alert instanceof HTMLDialogElement)) return
        if (!alert.id) return
        if (sessionStorage.getItem(`alert-closed-${alert.id}`)) return

        if (typeof alert.show === "function") {
            alert.show()
        }

        const close = alert.querySelector<HTMLButtonElement>('.alert__close')
        close?.addEventListener('click', () => {
            if (typeof alert.close === "function") {
                alert.close()
            }
            sessionStorage.setItem(`alert-closed-${alert.id}`, 'true')
        })
    })
}